import React from 'react';
import { Building2 } from 'lucide-react';

const DepartmentSettings = () => {
  return (
    <div className="divide-y divide-gray-200">
      <div className="p-6">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <Building2 className="w-5 h-5 text-gray-500" />
          Department Settings
        </h2>
      </div>
      <div className="p-6">
        <p>Department configuration coming soon...</p>
      </div>
    </div>
  );
};

export default DepartmentSettings; 